<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :remove-form="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Member', apiMethod: 'Members', form: () => import('../forms/MemberForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Auditor Member', apiMethod: 'AuditorMembers', parentForeignKey: 'memberId', form: () => import('../forms/AuditorMemberForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Blend Receival', apiMethod: 'BlendReceivals', parentForeignKey: 'supplierMemberId', form: () => import('../forms/BlendReceivalForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Member Certificate', apiMethod: 'MemberCertificates', parentForeignKey: 'memberId', form: () => import('../forms/MemberCertificateForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Member Operation', apiMethod: 'MemberOperations', parentForeignKey: 'memberId', form: () => import('../forms/MemberOperationForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Request', apiMethod: 'Requests', parentForeignKey: 'memberId', form: () => import('../forms/RequestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sampling', apiMethod: 'Samplings', parentForeignKey: 'memberId', form: () => import('../forms/SamplingForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Certificates', value: 'memberId', isCard: true, table: () => import('../tables/MemberCertificatesTable') },
                ],
                mainForm: () => import('../forms/MemberForm'),
                claimName: 'Members',
                apiMethod: 'Members',
            }
        }
    };
</script>
